import React, { useEffect } from "react";
import { Accordion, AccordionDetails, AccordionSummary, CircularProgress, Box, Button, Checkbox, Divider, Table, TableBody, TableCell, TableHead, TableRow, FormControl, FormControlLabel, FormLabel, Grid, Input, InputAdornment, Paper, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { useState, useRef, useMemo } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import InputStyle from "../../../assets/InputStyle";
import flagIcon from "../../../images/flagIcon.png";
import { Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '../../../images/upload.svg';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import JoditEditor from "jodit-react";
import { enqueueSnackbar } from "notistack";
import { createProfile } from "../../../actions/userAuth";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Education = () => {
    const [age, setAge] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedYear1, setSelectedYear1] = useState('');
    const [selectedMonth1, setSelectedMonth1] = useState('');

    const [selectedMonth, setSelectedMonth] = useState('');
    const [coachingField, setCoachingField] = useState('');
    const [coachingSpecification, setCoachingSpecification] = useState('');
    const [coachingCertification, setCoachingCertification] = useState('');
    const [experience, setExperience] = useState('');
    const [allWorkExperience, setAllWorkExperience] = useState([]);
    const [currentlyWorking, setCurrentlyWorking] = useState(false);
    const [fresherCandidate, setFresherCandidate] = useState(false);
    const [experiencedCandidate, setExperiencedCandidate] = useState(false);

    const [industrySpecialization, setIndustrySpecialization] = useState('');
    const [industryField, setIndustryField] = useState('');
    const [industryDescription, setIndustryDescription] = useState('');
    const [industryExperience, setIndustryExperience] = useState('');
    const [loading, setLoading] = useState(false);

    const [designation, setDesignation] = useState('');
    const [employeeType, setEmployeeType] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [location, setLocation] = useState('');
    const [workExperience, setworkExperience] = useState('');
    const [value, setValue] = useState("");
    const editor = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const months = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
    ];

    const {user} = useSelector((state) => ({...state}));
    useEffect(()=>{
        if(user?.workExperience?.length > 0){
            setAllWorkExperience(user?.workExperience);
        }
    },[user]);

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };
    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleMonthChange1 = (event) => {
        setSelectedMonth1(event.target.value);
    };
    const handleYearChange1 = (event) => {
        setSelectedYear1(event.target.value);
    };

    // Get the current year
    const currentYear = new Date().getFullYear();

    // Generate an array of the last 30 years
    const last30Years = Array.from({ length: 30 }, (_, index) => currentYear - index);
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const handleAddWorkExperiance = (event) => {
        event.stopPropagation();
        if (!designation || !employeeType || !companyName || !location || !value ) {
            enqueueSnackbar("Please fill all importatnt field", { variant: 'warning' });
        } else {
            let val = { designation: designation, employeeType: employeeType, companyName: companyName, location: location, currentlyWorking: currentlyWorking, description: value, startDate: `${selectedYear} - ${selectedMonth}`, endDate: `${selectedYear1} - ${selectedMonth1}` };
            setAllWorkExperience(oldArr => [...oldArr, val]);
        }

    }

    const handleSubmit = () => {
        setLoading(true)
        let payload = {
            workExperience: allWorkExperience,
            experienced: experiencedCandidate,
            fresher: fresherCandidate,
            isProfileCompleted:true
        }

        let user = JSON.parse(localStorage.getItem("user"));

        dispatch(createProfile(payload, user._id, user.role, (data) => {
            enqueueSnackbar(data.data.message, { variant: 'success' });
            navigate('/candidate/dashboard');
        }, (err) => {
            enqueueSnackbar("Error Occured! please try again", { variant: 'error' });
            setLoading(true)

        }, localStorage.getItem("refreshToken")))
    }

    return (
        <>
            <Box py={3}>
                <Box sx={{ backgroundColor: '#F6F8F9', px:{md:5, xs:1}, py: 5, borderRadius: '4px', mx: {md:5, xs:1} }}>

                    <Paper sx={{ mx: 4, px:{md:{md:5, xs:1}, xs:2}, pb: 5 }}>
                        <Box py={3} my={2}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Typography variant="h5" sx={{ color: '#000', fontWeight: '600' }}>Work Experience</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Button sx={{
                                        backgroundColor: '#2544EE',
                                        borderRadius: '5px',
                                        mx: 5,
                                        px: 5,
                                        float: 'right',
                                        '&:hover': {
                                            backgroundColor: '#FFF',
                                            color: '#2544EE',
                                        },
                                    }}
                                        variant="contained"
                                        onClick={handleAddWorkExperiance}>
                                        <AddIcon /> Add
                                    </Button>
                                </Grid>
                            </Grid>
                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                        </Box>

                        <Box>
                            <FormControl sx={{ display: 'block' }}>
                                <Box >


                                    <FormControlLabel control={<Checkbox onChange={(e) => setFresherCandidate(e.target.checked)} checked={fresherCandidate} />}
                                        label={
                                            <Typography variant="h6" >I am Fresher</Typography>
                                        } />

                                    <FormControlLabel control={<Checkbox onChange={(e) => setExperiencedCandidate(e.target.checked)} checked={experiencedCandidate} />}
                                        label={
                                            <Typography variant="h6" >I am Experienced</Typography>
                                        } />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Designation
                                            </Typography>
                                            <Box >
                                                <select
                                                    className="profile-skills-box mb-3"
                                                    value={designation}
                                                    onChange={(e) => setDesignation(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select </option>
                                                    <option value="Team Lead">Team Lead</option>
                                                    <option value="Software Developer">Software Developer</option>
                                                    <option value="Human Resource">Human Resource</option>
                                                </select>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Employee Type*
                                            </Typography>
                                            <Box >

                                                <select
                                                    className="profile-skills-box mb-3"
                                                    value={employeeType}
                                                    onChange={(e) => setEmployeeType(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Full-time">Full-time</option>
                                                    <option value="Part-time">Part-time</option>
                                                    <option value="Contract">Contract</option>
                                                </select>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Company Name*
                                            </Typography>
                                            <Box >
                                                <input
                                                    className="profile-skills-box mb-3"
                                                    value={companyName}
                                                    onChange={(e) => setCompanyName(e.target.value)}
                                                    placeholder="Enter your Coarse Name"
                                                    require
                                                />
                                            </Box>

                                            <FormControlLabel control={<Checkbox onChange={(e) => setCurrentlyWorking(e.target.checked)} checked={currentlyWorking} />}
                                                label={
                                                    <Typography variant="h6" >I am Currently Working in This Role</Typography>
                                                } />
                                        </Grid>



                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"

                                            >
                                                Location
                                            </Typography>
                                            <Box >
                                                <input
                                                    className="profile-skills-box mb-3"
                                                    value={location}
                                                    onChange={(e) => setLocation(e.target.value)}
                                                    placeholder="Enter your Coarse Name"
                                                    require
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item md={12} sx={{ margin: '1rem 0px' }}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Description*
                                            </Typography>
                                            <JoditEditor
                                                ref={editor}
                                                onChange={(newContent) => setValue(newContent)}
                                                value={value}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Start Date*
                                            </Typography>

                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6}>
                                                    <Box >
                                                        <Select
                                                            className="input-box mb-3"
                                                            value={selectedYear}
                                                            onChange={handleYearChange}
                                                            displayEmpty
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Year
                                                            </MenuItem>
                                                            {last30Years.map((year) => (
                                                                <MenuItem key={year} value={year}>
                                                                    {year}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Box>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                    <Box >
                                                        <Select
                                                            className="input-box mb-3"
                                                            value={selectedMonth}
                                                            onChange={handleMonthChange}
                                                            displayEmpty
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Month
                                                            </MenuItem>
                                                            {months.map((month) => (
                                                                <MenuItem key={month.value} value={month.value}>
                                                                    {month.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                End Date*
                                            </Typography>

                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6}>
                                                    <Box >
                                                        <Select
                                                            disabled={currentlyWorking}
                                                            className="input-box mb-3"
                                                            value={selectedYear1}
                                                            onChange={handleYearChange1}
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Year
                                                            </MenuItem>
                                                            {last30Years.map((year) => (
                                                                <MenuItem key={year} value={year}>
                                                                    {year}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>

                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Box >
                                                        <Select
                                                            disabled={currentlyWorking}
                                                            className="input-box mb-3"
                                                            value={selectedMonth1}
                                                            onChange={handleMonthChange1}
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Month
                                                            </MenuItem>
                                                            {months.map((month) => (
                                                                <MenuItem key={month.value} value={month.value}>
                                                                    {month.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>


                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </FormControl>

                            {
                                allWorkExperience && allWorkExperience.length > 0
                                    ?
                                    <Table>
                                        <TableHead>
                                            <TableCell>
                                                Designation
                                            </TableCell>
                                            <TableCell>
                                                Employee Type
                                            </TableCell>
                                            <TableCell>
                                                Company Name
                                            </TableCell>
                                            <TableCell>
                                                Location
                                            </TableCell>
                                            <TableCell>
                                                Currently Working
                                            </TableCell>
                                            <TableCell>
                                                Description
                                            </TableCell>
                                            <TableCell>
                                                Start Date
                                            </TableCell>
                                            <TableCell>
                                                End Date
                                            </TableCell>
                                        </TableHead>
                                        <TableBody>
                                            {allWorkExperience.map((item, index) => (
                                                <>
                                                    {/* courseType, specialization, degreeYears, school, passingYear, percentageGrade, degreeImage */}
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            {item.designation}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.employeeType}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.companyName}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.location}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.currentlyWorking ? 'Yes' : 'No'}
                                                        </TableCell>
                                                        <TableCell dangerouslySetInnerHTML={{ __html: item.description }}>

                                                        </TableCell>
                                                        <TableCell>
                                                            {item.startDate}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.currentlyWorking ? "Currently Working" : item.endDate}
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    :
                                    ""
                            }
                        </Box>

                        <Box my={3}>
                            <Button sx={{
                                backgroundColor: '#2544EE',
                                borderRadius: '2rem',
                                px: 5,
                                '&:hover': {
                                    backgroundColor: '#FFF',
                                    color: '#2544EE',
                                },
                            }}
                                disabled={loading}
                                onClick={handleSubmit}
                                variant="contained">
                                {
                                    loading
                                        ?
                                        <CircularProgress size={24} />
                                        :
                                        "Create"
                                }
                            </Button>
                        </Box>
                    </Paper>
                </Box>

            </Box >
        </>
    );
}

export default Education;